import moment from "moment/moment";

moment.updateLocale('ru', {
  week: {
    dow : 1, // Monday is the first day of the week.
  }
});

export default moment